import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { ITemplate } from '@obvious.tech/constellation'

export const Template = defineEntity('Template', {
  endpoint: 'connectors/api/Template',
  schema: SNoop<ITemplate>(),
})
